import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热播风云榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            实时热度排行，发现大家都在追的好剧
          </p>
        </div>

        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-lg hover:bg-background-200/50 transition-colors duration-200 cursor-pointer"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-md font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs px-2 py-0.5 bg-primary-100 text-primary-700 rounded-full font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-500 mt-0.5 truncate">
                  {item.description}
                </p>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                  {item.category}
                </span>
                <span className="font-heading text-lg font-bold text-primary-500 whitespace-nowrap">
                  {item.score}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}